import _ from 'underscore';

const validateBeam = (str) => {
  const num = Number(str);

  if (_.isNaN(num)) {
    return false;
  }

  return num >= 0 && num <= 255;
};

export function validateColor(propertyValue) {
  const beams = propertyValue.split(',');
  if (_.size(beams) !== 3) {
    return false;
  }

  return _.every(beams, validateBeam);
}
